export default "__VITE_ASSET__57014058__"